import { usePageTransition } from '../context/TransitionContext.jsx';

export default function Card({ title, description, href, imageSrc, iframeSrc }) {
  const { navigateTo } = usePageTransition();
  const isInternal = href && href.startsWith('/');

  function handleClick(e) {
    e.preventDefault();
    document.activeElement?.blur();
    navigateTo(href);
  }

  return (
    <div className="card">
      {iframeSrc && (
        <iframe
          src={iframeSrc}
          title={title}
          width="100%"
          scrolling="no"
          frameBorder="no"
          allow="autoplay"
        />
      )}
      {!iframeSrc && imageSrc && <img src={imageSrc} alt={title} />}
      <h2>
        {isInternal ? (
          <a href={href} title={title} onClick={handleClick}>
            {title}
          </a>
        ) : (
          <a href={href || '#'} title={title} target="_blank" rel="noreferrer">
            {title}
          </a>
        )}
      </h2>
      {description && <p>{description}</p>}
    </div>
  );
}
